export const COOKIEBOT_ID = 'b1cbd016-d0c4-4ff6-8ad5-776670401f09'
export const GOOGLE_MEASURE_ID = 'G-LT5PS4RGKY'
export const GOOGLE_TAG_ID = 'GTM-KGXFM7SL'
export const GOOGLE_AD_SENSE = 'ca-pub-7898344643050871'
